<div class="dialog-wrapper" *ngIf="showContentFull; else elseBlock">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close dialog"
        (click)="click()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div
    class="top-wrapper light-blue-bg p-50"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <mat-icon>lock</mat-icon>
  </div>
  <div class="form-wrapper">
    <p
      class="font-weight-800 mb-25"
      [(ngModel)]="pinRegisterConfirm"
      ngDefaultControl
    >
      {{ pinRegisterConfirm | translate }}
    </p>
    <form (input)="onKeypressEvent($event)" (keyup)="onKeypressEvent($event)">
      <table cellspacing="0" fxLayout="row" fxLayoutAlign="center stretch">
        <tr>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                matInput
                type="password"
                maxlength="1"
                (input)="onInputEntry($event)"
                #input1
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="2"
                matInput
                type="password"
                maxlength="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                (input)="onInputEntry($event)"
                #input2
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="3"
                matInput
                type="password"
                maxlength="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                (input)="onInputEntry($event)"
                #input3
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="4"
                matInput
                type="password"
                maxlength="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                (input)="onInputEntry($event)"
                #input4
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="5"
                matInput
                type="password"
                maxlength="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                (input)="onInputEntry($event)"
                #input5
              />
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="pin-input">
              <input
                (keypress)="numberOnly($event)"
                data-no="6"
                matInput
                type="password"
                maxlength="1"
                (focus)="focusFunction($event)"
                (focusout)="focusOutFunction($event)"
                (input)="onInputEntry($event)"
                #input6
              />
            </mat-form-field>
          </td>
        </tr>
      </table>
    </form>
    <ul *ngIf="showContent">
      <li>{{ "Should not be same number" | translate }}</li>
      <li>{{ "Should not be continued number" | translate }}</li>
    </ul>
    <div
      *ngIf="hasError"
      [(ngModel)]="errorMessage"
      class="red-900-fg error-message"
      name="errorMessage"
      ngDefaultControl
    >
      {{ errorMessage | translate }}
    </div>
    <button
      mat-stroked-button
      color="accent"
      type="submit"
      [disabled]="checkInputFill"
      [(ngModel)]="pinSubmitConfirm"
      (click)="onPinSubmit()"
      ngDefaultControl
    >
      {{ pinSubmitConfirm | translate }} <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
<ng-template #elseBlock>
  <div class="blocked-user">
    <p class="mat-title font-weight-900 red-A700-fg">
      {{
        "Access to your account is prohibited, Please contact the seyarkalam"
          | translate
      }}
    </p>
    <button
      (click)="logout()"
      mat-stroked-button
      mat-dialog-close
      color="accent"
    >
      <mat-icon>exit_to_app</mat-icon>
      <span>{{ "Logout" | translate }}</span>
    </button>
  </div>
</ng-template>
